import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Account } from '../models/account.model';
import { AccountModel } from '../models/account-model.model';

@Injectable()
export class AccountService {
  private readonly url: string = 'Api/UserProfile';
  //private readonly url: string = 'https://localhost:5001';
  constructor(private http: HttpClient) {}

  public Setup(account: Account) {
    const accountModel = this.getAccountModel(account);
    return this.http.post(this.url, accountModel);
  }

  private getAccountModel(account: Account): AccountModel {
    return {
      contactWithAdditionalServices: account.outOptions.contactWithAdditionalServices,
      contactWithMarketingMaterials: account.outOptions.contactWithMarketingMaterials,
      isAcceptedTerms: account.isAcceptedTerms,
      firstName: account.firstName,
      lastName: account.lastName,
      title: account.title,
      workPhone: account.workPhone,
      mobilePhone: account.mobilePhone,
      companyName: account.companyName,
      department: account.department,
      street1: account.street1,
      street2: account.street2,
      country: account.country,
      state: account.state,
      city: account.city,
      zip: account.zip,
      password: account.passwordState.value === undefined ? null : account.passwordState.value,
      securityQuestion: account.qna.question === undefined ? null : account.qna.question,
      securityAnswer: account.qna.answer === undefined ? null : account.qna.answer,
      email: account.email,
      resetGuid: account.resetGuid
    };
  }
}
